import React from 'react';

import { sortBy, filter } from 'lodash';

import { Flex } from 'antd';
import Loader from 'components/Loading/Loader';

import {
	useGetPricesQuery,
	useMakePaymentMutation
} from 'graph/dist/generated';
import { Button } from 'antd';
import ButtonGroup from 'antd/es/button/button-group';
import { useTranslation } from 'react-i18next';

export const PlansList = (props: any) => {
	const { t } = useTranslation();
	const [makePayment] = useMakePaymentMutation();
	const [loading, setLoading] = React.useState<boolean>(false);
	const [projectsCount, setProjectCount] = React.useState<Number>(3);
	const [billingMode, setBillingMode] = React.useState<String>('year');
	const getPricesQuery = useGetPricesQuery();

	const startPaymentProcess = async (price: string) => {
		setLoading(true);
		let result = await makePayment({
			variables: {
				price: price,
				referer: document.location.href.replace(/\/profile.*/, '')
			}
		});
		console.log('result', result.data.makePayment);
		document.location.href = result.data.makePayment;

		return true;
	};

	return (
		<div className="PlansList text-center">

			<Flex align="center" justify="center">
				<div className="mr-1">
					<Button className="mr-05" type={[billingMode == "month" ? "primary" : ""].join(" ")} onClick={() => setBillingMode("month")}>{t('messages.subscription.billing_monthly')}</Button>
					<Button type={[billingMode == "year" ? "primary" : ""].join(" ")} onClick={() => setBillingMode("year")}>{t('messages.subscription.billing_yearly')} <small style={{ color: "red" }}>{t('messages.subscription.billing_yearly_save')}</small></Button>
				</div>

				<div>
					<Button className="mr-05" type={[projectsCount == 3 ? "primary" : ""].join(" ")} onClick={() => setProjectCount(3)}>3</Button>
					<Button className="mr-05" type={[projectsCount == 6 ? "primary" : ""].join(" ")} onClick={() => setProjectCount(6)}>6</Button>
					<Button type={[projectsCount == 10 ? "primary" : ""].join(" ")} onClick={() => setProjectCount(10)}>10+</Button>
				</div>
			</Flex>

			<div className="plans">


				{getPricesQuery.loading ? (
					<Loader></Loader>
				) : (
					<>
						{filter(
							sortBy(getPricesQuery.data?.getPrices, 'unit_amount'),
							(p: any) =>
								JSON.parse(p.recurring).interval == billingMode
								&& (JSON.parse(p.metadata).projects == projectsCount || (JSON.parse(p.metadata).projects == 6 && projectsCount == 10))
						).map((p, index) => {
							let metadata = JSON.parse(p.metadata);
							let recurringInfos = JSON.parse(p.recurring);
							return (
								<div className="plan" key={index}>
									<h3>{metadata.name?.split(" - ", 2)[1]}</h3>
									<p>{metadata.description.split(" - ").map(
										p => <>{p}<br /></>
									)} </p>

									{
										projectsCount < 10 ?
											<>
												<a
													className={[
														'paymentButton',
														loading ? 'disabled' : ''
													].join(' ')}
													onClick={() => startPaymentProcess(p.id)}
												>
													{!loading && t('messages.subscription.choose_now')}
													{loading && (
														<Loader
															size={20}
															color="white"
														></Loader>
													)}
												</a>

												<div className="price">
													{(recurringInfos.interval == 'month'
														? p.unit_amount / 100
														: p.unit_amount / 1200
													).toFixed(0)}{' '}
													{(p.currency || 'chf').toUpperCase()}/month
												</div>
											</>
											: <>
												<a
													className={['paymentButton'].join(' ')}
													href="mailto:contact@gerositus.com"
												>
													Contact us
												</a>
												<div className="price">
													&nbsp;
												</div>
											</>
									}
								</div>
							);
						})}

					</>
				)}
			</div>
		</div>
	);
};

export default PlansList;
